import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import PdpSharedDetailAttributeLink from './helpers/PdpSharedDetailAttributeLink';

// helpers
import get from 'lodash.get';

function PdpSharedDetailMetal({ item }) {
    return (
        <PdpSharedDetailAttributeLink
            item={item}
            dataTn="pdp-spec-metal"
            attributes={get(item, 'attributes.metal')}
        />
    );
}

PdpSharedDetailMetal.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailMetal, {
    item: graphql`
        fragment PdpSharedDetailMetal_item on Item {
            ...PdpSharedDetailAttributeLink_item
            attributes {
                metal: material(attributeType: metal) {
                    ...PdpSharedDetailAttributeLink_attributes
                }
            }
        }
    `,
});
